angular.module('impactx.list').directive('ixListAutoCompleteFilter', function(){
    return {
        restrict: 'E',
        scope: {
            field: '=',
            suffix: '=',
            columnName: '=',
            popupFilter: "="
        },
        require: '^stTable',
        templateUrl: 'shared/list/templates/listautocompletefilter.tmpl.html',
        link: function (scope, element, attr, ctrl) {
            scope.change = function change () {
                ctrl.search(scope.popupFilter.searchText, scope.columnName);
            };
            scope.clear = function() {
                scope.popupFilter.searchText = '';
                ctrl.search(scope.popupFilter.searchText, scope.columnName);
            };
            if (scope.popupFilter.searchText)
            {
                scope.change();
            }

        }
    }
});
